import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ExportIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="export" ref={ref} {...props}>
      <path d="M20.79,7.52a.72.72,0,0,1-.06.29.78.78,0,0,1-.16.24L17,11.6a.75.75,0,0,1-1.06,0,.75.75,0,0,1,0-1.06l2.27-2.27H16.72a7.26,7.26,0,0,0-7.25,7.25.75.75,0,1,1-1.5,0,8.76,8.76,0,0,1,8.75-8.75h1.51L16,4.49A.75.75,0,0,1,17,3.43L20.57,7a.78.78,0,0,1,.16.24A.72.72,0,0,1,20.79,7.52Zm-1,8.48V14a.75.75,0,0,0-1.5,0v2A2.25,2.25,0,0,1,16,18.25H8A2.25,2.25,0,0,1,5.75,16V8A2.25,2.25,0,0,1,8,5.75h2a.75.75,0,0,0,0-1.5H8A3.75,3.75,0,0,0,4.25,8v8A3.75,3.75,0,0,0,8,19.75h8A3.75,3.75,0,0,0,19.75,16Z" />
    </Icon>
  ),
) as IconWithRender;

ExportIcon.displayName = 'ExportIcon';
ExportIcon.renderIcon = (props) => <ExportIcon {...props} />;
export default ExportIcon;
